import { ModalRoot, Modal, ModalHeader, ModalContent, ModalFooter, Button } from '@pella/sash-framework';
import { convertISO } from '../../../utils';

import * as classes from './DuplicateRequestModal.module.css';

const NO_QUANTITY = 'N/A';

/**
 * DuplicateRequestModal Atom Component
 * Warns the user that open requests already exist for this item before their request is submitted.
 * @param {Local.DuplicateRequestModalProps} props - Component props
 */
export const DuplicateRequestModal = ({ isOpen, requests, onCancel, onProceed }) => (
  <ModalRoot open={isOpen}>
    <Modal className={classes.container} showClose={false}>
      <ModalHeader>Open Requests Found</ModalHeader>
      <ModalContent>
        This item has already been requested. Review the open requests below before proceeding.
        <div className={classes.wrapper}>
          <div className={`${classes.row} ${classes.header}`}>
            <div>Date</div>
            <div>Username</div>
            <div>Status</div>
            <div>Qty</div>
          </div>
          {requests.map((request) => (
            <div key={request.id} className={classes.row} data-testid={`duplicateRequest-${request.id}`}>
              <div>{convertISO(request.creationDate)}</div>
              <div>{request.requestorId}</div>
              <div>{request.status}</div>
              {/* Actions without a quantity store 0 rather than null, so both mean "no quantity" */}
              <div>{request.requestQty || NO_QUANTITY}</div>
            </div>
          ))}
        </div>
      </ModalContent>
      <ModalFooter className={classes.modalFooter}>
        <Button color='secondary' onClick={onCancel}>
          CANCEL
        </Button>
        <Button color='primary' onClick={onProceed}>
          PROCEED
        </Button>
      </ModalFooter>
    </Modal>
  </ModalRoot>
);
